<template>
<div class="planning-fc-wrapper pwgs-bloqueos" :class="{ 'pwgs-vista-mes': esVistaMes }" :style="{ width: anchoPlanning }">

  <!-- TOOLTIP DÍA / FRANJA (solo lectura) -->
  <div v-if="overlayDiaVisible && (citasDiaHover.length || tituloDiaHover)"
    class="fc-overlay-panel" @mouseenter="cancelarCerrarDia" @mouseleave="iniciarCerrarDia"
    :style="{ position:'fixed', top: overlayDiaY + 'px', left: overlayDiaX + 'px', zIndex: 9999, maxWidth:'320px', maxHeight:'60vh', overflowY:'auto' }">
    <b v-if="tituloDiaHover">{{ tituloDiaHover }}</b>
    <!-- Nuevas vacaciones en la franja (vista semanal) -->
    <div v-if="franjaTooltip" style="text-align:center;margin-bottom:4px">
      <button class="btn btn-primary btn-sm" style="font-size:0.75em;padding:2px 10px"
        @click.stop="nuevasVacacionesDesdeFranja()">Crear vacaciones</button>
    </div>
    <div v-for="(c, i) in citasDiaHover" :key="i" style="margin-top:3px">
      <div style="display:flex;align-items:flex-start;gap:5px">
        <span :style="{ background: c.color, display:'inline-block', width:'10px', height:'10px', borderRadius:'2px', flex:'0 0 auto', border:'1px solid #0003', marginTop:'2px' }"></span>
        <span style="font-size:0.75em;min-width:0">
          <template v-if="c.descripcion">
            <b>{{ c.referencia }}</b> · <b>{{ c.operario }}</b><br>
            {{ c.horaIni }}-{{ c.horaFin }} · {{ c.direccion || c.titulo }}
          </template>
          <template v-else><b>{{ c.operario }}</b> · {{ c.horaIni }}-{{ c.horaFin }} · {{ c.titulo }}</template>
        </span>
      </div>
    </div>
  </div>

  <div v-if="spinner" class="spinner"></div>

  <div v-if="ocultar" class="alert alert-danger" role="alert">
    <h4>No hay operarios disponibles con los filtros seleccionados</h4>
  </div>

  <div v-show="!ocultar">
    <FullCalendar ref="fullCalendar" :options="calendarOptions" />
  </div>

  <OverlayPanel :dismissable="true" ref="calenddos">
    <Calendar showOtherMonths selectOtherMonths v-model="fechacalddos" inline />
  </OverlayPanel>

  <!-- OVERLAY CITA (solo lectura) -->
  <div v-if="overlayVisible && eventoHover"
    class="fc-overlay-panel"
    :style="{ position: 'fixed', top: overlayY + 'px', left: overlayX + 'px', zIndex: 9999 }"
    @mouseenter="cancelarCerrarOverlay"
    @mouseleave="iniciarCerrarOverlay">
    <b>{{ nombreevento }}</b>
    <p v-html="descripcionevento"></p>
  </div>

  <!-- OVERLAY BLOQUEADO / VACACIONES -->
  <div v-if="overlayBloqVisible"
    class="fc-overlay-panel"
    :style="{ position: 'fixed', top: overlayBloqY + 'px', left: overlayBloqX + 'px', zIndex: 9999 }">
    <p>{{ descripcionbloq }}</p>
  </div>

  <!-- DIALOG NUEVA VISITA -->
    <Dialog ref="dialog2" :blockScroll="false" @hide="onHideNuevaCita" draggable="false" v-model:visible="vacacionesVisible"
      :header="$t('general.nuevacita') + ' (' + new Date(eventoacrear).toLocaleDateString('es-ES') + ')'"
      :style="{ width: '45vw', height: '80vh' }">
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Operario(s)</label><br>
            <select v-model="operarioseleccionado" class="form-control custom-select" style="width:100%">
              <option v-for="operario in operariosCita" :value="operario.id" :key="operario.id">{{ operario.label }}</option>
            </select>
          </div>
          <!-- ▲ FIN CAMBIO 1 -->
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Visita a</label><br>
            <select style="width:100%" v-model="clienteseleccionado" class="custom-select form-control-sm">
              <option v-for="cliente in clientes" :key="cliente" :value="cliente">{{ cliente }}</option>
            </select>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Descripción visita</label><br>
            <Textarea placeholder="Descripción de la visita" style="width:100%" autoResize v-model="descripcionvisitas"></Textarea>
            <label><span v-if="descripcionvisitas">{{ descripcionvisitas.length }}</span> carácteres. Mínimo {{ descripcionminima }} Caracteres.</label><br>
            <div style="text-align:end">
              <button @click="agregarvisita()" class="btn btn-primary btn-sm">Añadir visita</button>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <table class="table table-sm">
            <tbody>
              <tr v-for="descr in clientedescripcion" :key="descr.cliente"><td>{{ descr.nombre }}</td></tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row" style="margin-bottom:20px;margin-top:10px">        
        <div class="col-md-3">
          <div class="form-group">
            <label>{{ $t('general.FechaInicio') }}</label><br>
            <Calendar style="width:100%" v-model="fechaInicioVacaciones" showTime hourFormat="24" :stepMinute="10" dateFormat="dd/mm/yy" />
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>{{ $t('general.fechafin') }}</label><br>
            <Calendar style="width:100%" v-model="fechaFinVacaciones" showTime hourFormat="24" :stepMinute="10" dateFormat="dd/mm/yy" />
          </div>
        </div>
      </div>
      <div class="row" style="margin:25px 0">
        <div class="col-md-4">
          <strong>Propiedades</strong>
          <div class="form-group">
            <div class="custom-control custom-checkbox">
              <input v-model="prioritaria" class="custom-control-input" type="checkbox" id="prioritaria3" true-value="1" false-value="0">
              <label style="font-weight:normal" for="prioritaria3" class="custom-control-label">{{ $t('general.prioritaria') }}</label>
            </div>
            <div class="custom-control custom-checkbox">
              <input v-model="nomodificar" class="custom-control-input" type="checkbox" id="nomodificar3" true-value="1" false-value="0">
              <label style="font-weight:normal" for="nomodificar3" class="custom-control-label">{{ $t('general.nomodificar') }}</label>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12" style="margin-top:25px">
        <div style="text-align:center">
          <button @click="guardarVacaciones(fechaInicioVacaciones, fechaFinVacaciones)" class="btn btn-primary btn-sm">Guardar vacaciones</button>
        </div>
      </div>
    </Dialog>

  <!-- DIALOG CONFIRMAR ELIMINAR VACACIONES / BLOQUEOS -->
  <Dialog :header="bloqueAEliminar?.tipo === 'VACACIONES' ? 'Eliminar vacaciones' : 'Eliminar bloqueo'"
    :blockScroll="false" v-model:visible="bloqueConfirmar" modal :style="{ width: '25rem' }" :draggable="false">
    <p style="text-align:center">
      ¿Seguro que quieres eliminar este {{ bloqueAEliminar?.tipo === 'VACACIONES' ? 'periodo de vacaciones' : 'bloqueo' }}?
    </p>
    <p v-if="bloqueAEliminar && bloqueAEliminar.content" style="text-align:center;font-size:0.9em">
      {{ bloqueAEliminar.content }}
    </p>
    <div class="row mt-3">
      <div class="col-md-3"></div>
      <div class="col-md-3">
        <button style="width:100%;background:green;border:0" @click="eliminarBloque()" class="btn btn-primary btn-sm">Aceptar</button>
      </div>
      <div class="col-md-3">
        <button style="width:100%;background:red;border:0" @click="bloqueConfirmar = false" class="btn btn-primary btn-sm">Cancelar</button>
      </div>
    </div>
  </Dialog>
</div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue3';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid';
import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid';
import scrollGridPlugin from '@fullcalendar/scrollgrid';
import OverlayPanel from 'primevue/overlaypanel';
import Dialog from 'primevue/dialog';
import Calendar from 'primevue/calendar';
import Textarea from 'primevue/textarea';
import { PwgsApi } from '../../../services/PwgsApi';

export default {
  name: 'PlanningVacaciones',
  components: { FullCalendar, Dialog, Calendar, Textarea, OverlayPanel },
  props: ['operarios', 'operariosseleccionados', 'cambios', 'fechacal', 'guardia'],

  data() {
    return {
      nomodificar: '0',
      prioritaria: '0',
      operariosCita: [],
      clientesubir:[],
      clientedescripcion:[],
      descripcionvisitas:'',
      descripcionminima: 0,
      clientes: ['Vacaciones'],
      clienteseleccionado:'Vacaciones',
      operarioseleccionado: [],
      esVistaDiaria: true,
      esVistaMes: false,
      spinner: false,
      ocultar: false,
      // Tooltips
      overlayDiaVisible: false,
      overlayDiaX: 0, overlayDiaY: 0,
      citasDiaHover: [],
      tituloDiaHover: '',
      franjaTooltip: null,
      overlayVisible: false,
      overlayX: 0, overlayY: 0,
      overlayHideTimer: null,
      overlayBloqVisible: false,
      overlayBloqX: 0, overlayBloqY: 0,
      eventoHover: null,
      descripcionevento: '',
      nombreevento: '',
      descripcionbloq: '',
      fechacalddos: null,
      // Nuevo vacaciones
      vacacionesVisible: false,
      guardandoVacaciones: false,
      operariosDisponibles: [],
      operariosVacaciones: [],
      fechaInicioVacaciones: null,
      fechaFinVacaciones: null,
      descripcionVacaciones: '',
      // Eliminar vacaciones
      bloqueConfirmar: false,
      bloqueAEliminar: null,
      // Festivos
      listadofestivos: [],
      anyoactual: String(new Date().getFullYear()),
      mesactual: new Date().getMonth() + 1,
      diaactual: new Date().getDate(),
      propiedadescalendario: '',
      calendarOptions: {
        plugins: [dayGridPlugin, interactionPlugin, timeGridPlugin, resourceTimeGridPlugin, scrollGridPlugin],
        initialView: 'resourceTimeGridDay',
        schedulerLicenseKey: '0153147561-fcs-1782138727',
        locale: 'es',
        resources: [],
        views: {
          timeGridWeek: { slotEventOverlap: false },
          resourceTimeGridDay: { slotEventOverlap: false },
          dayGridMonth: { selectable: false },
        },
        firstDay: 1,
        dayMinWidth: 150,
        slotDuration: '00:30:00',
        snapDuration: '00:15:00',
        allDaySlot: false,
        eventOverlap: true,
        height: 'auto',
        slotMinTime: '07:00:00',
        slotMaxTime: '22:00:00',
        nowIndicator: true,
        // Las citas son de solo lectura: aquí solo se crean/eliminan vacaciones
        editable: false,
        eventStartEditable: false,
        eventDurationEditable: false,
        eventResourceEditable: false,
        resourceOrder: 'name',
        // Selección de franjas para crear las vacaciones
        selectable: true,
        selectOverlap: (event) => {
          const tipo = event.extendedProps?.tipo || event.title;
          return !['BLOQUEADO','VACACIONES'].includes(tipo);
        },
        selectMirror: true,
        unselectAuto: true,
        customButtons: {
          nuevasvacaciones: { text: 'Nuevas Vacaciones', click: null },
        },
        headerToolbar: {
          left: 'nuevasvacaciones',
          center: 'prev title next today',
          right: 'resourceTimeGridDay,timeGridWeek,dayGridMonth',
        },
        buttonText: { today: 'Hoy', day: 'Día', week: 'Semana', month: 'Mes' },
        datesSet: null,
        select: null,
        eventClick: null,
        eventMouseEnter: null,
        eventMouseLeave: null,
        eventContent: null,
        resourceLabelContent: null,
        slotLabelContent: null,
        events: null,
      },
    };
  },

  computed: {
    numRecursos() {
      const sel = Array.isArray(this.operariosseleccionados) ? this.operariosseleccionados : [];
      if (sel.length > 0) return sel.length;
      return Object.values(this.operarios || {}).length;
    },
    anchoPlanning() {
      if (!this.esVistaDiaria) return '100%';
      const n = this.numRecursos;
      if (!n || n >= 5) return '100%';
      return (n * 20) + '%';
    },
  },

  methods: {
    agregarvisita() {
      if (this.descripcionvisitas.length < this.descripcionminima) { alert('La descripción no contiene los carácteres mínimos.'); return; }
      if (this.clienteseleccionado) {
        const sub = { cliente: this.clienteseleccionado, descripcion: this.descripcionvisitas, nombre: this.clienteseleccionado };
        this.clientedescripcion.push(sub);
        this.clientesubir.push(this.clienteseleccionado);
        this.clientes = this.clientes.filter(c => c !== this.clienteseleccionado);
        this.clienteseleccionado = '';
      }
    },
    // ── Utilidades ────────────────────────────────────────────────────────────
    decode_utf8(s) { try { return decodeURIComponent(escape(s)); } catch (e) { return s; } },
    formatHora(date) {
      if (!date) return '';
      return new Date(date).toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
    },
    onHideNuevaCita() {
      this._bloquearScroll();
      setTimeout(() => this._desbloquearScroll(), 150);
    },
    sumarDias(dia, mes, año, n) {
      const f = new Date(año, mes - 1, dia);
      f.setDate(f.getDate() + n);
      return `${String(f.getDate()).padStart(2,'0')}-${String(f.getMonth()+1).padStart(2,'0')}-${f.getFullYear()}`;
    },
    _bloquearScroll() {
      this._scrollLocks = (this._scrollLocks || 0) + 1;
      if (this._scrollLockHandler) return;
      this._scrollLockY = (this._scrollY !== undefined && this._scrollY !== null) ? this._scrollY : window.scrollY;

      // Detectar interacción real del usuario (rueda, táctil, teclado)
      this._marcaUsuario = 0;
      this._userInputHandler = () => { this._marcaUsuario = Date.now(); };
      window.addEventListener('wheel', this._userInputHandler, { passive: true });
      window.addEventListener('touchmove', this._userInputHandler, { passive: true });
      window.addEventListener('keydown', this._userInputHandler);

      this._scrollLockHandler = () => {
        if (Date.now() - this._marcaUsuario < 150) {
          // Scroll iniciado por el usuario → seguirle, no corregir
          this._scrollLockY = window.scrollY;
        } else if (window.scrollY !== this._scrollLockY) {
          // Scroll programático (focus-restore, reflow) → revertir
          window.scrollTo(0, this._scrollLockY);
        }
      };
      window.addEventListener('scroll', this._scrollLockHandler);
    },
    // ── CSS global ────────────────────────────────────────────────────────────
    inyectarCSS() {
      if (document.getElementById('pwgs-fc-bloqueos-styles')) return;
      const s = document.createElement('style');
      s.id = 'pwgs-fc-bloqueos-styles';
      s.textContent = `
        .fc-timegrid-slot { height: 2.4em !important; }
        .fc-timegrid-slot-label-cushion { font-size:0.9em !important; font-weight:600; color:#333; padding:0 6px; white-space:nowrap; }
        .fc-timegrid-slot-minor .fc-timegrid-slot-label-cushion { font-weight:400; color:#999; }
        .fc-timegrid-axis, .fc-timegrid-slot-label { border-right: 2px solid #888 !important; }
        .fc-timegrid-slot-lane { border-top: none; }
        .fc-timegrid-slot-lane:not(.fc-timegrid-slot-minor) { background-color:#e8e8e8 !important; border-top: none !important; }
        .fc-timegrid-col { border-right: 1px solid #999 !important; position: relative; z-index: 2; }
        .fc-timegrid-slots { z-index: 1 !important; position: relative; }
        .fc-timegrid-cols { z-index: 2 !important; position: relative; border-left: 1px solid #999 !important; }
        .fc-col-header-cell { border-right: 1px solid #999 !important; border-bottom: none !important; border-top: none !important; }
        .fc-scrollgrid-section-header td { border-bottom: none !important; border-top: none !important; padding: 0 !important; }
        .fc-col-header { border-bottom: none !important; border-top: none !important; margin: 0 !important; }
        .fc-scrollgrid td, .fc-scrollgrid th { border-bottom: none !important; }
        .fc-timegrid-col:not(.fc-day-today) { background: transparent; }
        .fc-day-today { background: transparent !important; }
        .fc-col-header-cell-cushion { display:block; padding:4px; white-space:normal; }
        .fc-header-toolbar { margin-bottom:0 !important; padding-right:0.5em; }
        .fc-toolbar-title { border-radius:4px; padding:2px 6px; cursor:pointer; white-space:nowrap !important; font-size:2.1em !important; }
        .fc-toolbar.fc-header-toolbar { flex-wrap: nowrap !important; }
        .fc-toolbar-chunk { display:flex !important; align-items:center !important; white-space:nowrap !important; }
        .fc-view-harness { margin-top: 0 !important; }
        .fc .fc-toolbar { margin-bottom: 4px !important; }
        .fc-scrollgrid { border-top: none !important; }
        .fc .fc-col-header, .fc-scrollgrid-section-header, .fc-scrollgrid-section-header td {
          position: sticky !important; top: 72px !important; z-index: 50 !important; background: white !important;
        }
        .p-overlaypanel { z-index: 100000 !important; }
        .p-dialog-mask { z-index: 100000 !important; }
        .p-dialog { z-index: 100001 !important; }
        .p-datepicker, .p-multiselect-panel { z-index: 100002 !important; }
        .fc-event.GUARDIA    { background:rgba(255,87,87,1) !important; color:white !important; border:none !important; }
        .fc-event.OCUPADO    { background:rgba(0,47,255,1) !important; color:white !important; border:none !important; }
        .fc-event.BLOQUEADO  { background:rgba(71,98,104,1) !important; color:white !important; border:none !important; }
        .fc-event.VACACIONES { background:rgba(0,204,0,1) !important; color:white !important; border:none !important; }
        .fc-bg-event .fc-event-main, .fc-bg-event { height: 100%; }
        .fc-bg-event.BLOQUEADO, .fc-bg-event.OCUPADO, .fc-bg-event.VACACIONES { opacity: 1 !important; }
        .fc-event:hover .fc-event-btns { opacity:1 !important; }
        .fc-timegrid-event .fc-event-main { padding: 0 !important; }
        /* Las citas aquí son informativas: el cursor indica que no son editables */
        .fc-resourceTimeGridDay-view .fc-timegrid-event { cursor: default; margin-right: 1px !important; }
        .fc-resourceTimeGridDay-view .fc-timegrid-col-events { margin: 0 1px !important; }
        .fc-resourceTimeGridDay-view .fc-timegrid-event-harness > .fc-timegrid-event {
          inset-inline-start: 0 !important; inset-inline-end: 0 !important; left: 0 !important; right: 0 !important;
        }
        .fc-resourceTimeGridDay-view .fc-timegrid-event-harness-inset .fc-timegrid-event { box-shadow: none !important; }
        /* Mes: solo contadores y festivos */
        .fc-daygrid-event.CONTADOR, .fc-daygrid-event.FESTIVO_MES,
        .fc-event.CONTADOR, .fc-event.FESTIVO_MES {
          background: transparent !important; border: none !important; box-shadow: none !important; margin: 0 !important;
        }
        .fc-daygrid-day-events { display: flex; justify-content: center; }
        .fc-daygrid-event.CONTADOR .fc-event-main, .fc-daygrid-event.FESTIVO_MES .fc-event-main { display:flex; justify-content:center; }
        .fc-dayGridMonth-view .fc-daygrid-event:not(.CONTADOR):not(.FESTIVO_MES) { display: none !important; }
        .fc-dayGridMonth-view .fc-daygrid-day { cursor: pointer; }
        /* Semana: solo bloques resumen */
        .fc-event.RESUMEN { border: 1px solid rgba(0,0,0,0.15) !important; opacity: 0.85; cursor: default; }
        .fc-timeGridWeek-view .fc-timegrid-event:not(.RESUMEN),
        .fc-timeGridWeek-view .fc-daygrid-event:not(.RESUMEN),
        .fc-timeGridWeek-view .fc-bg-event { display: none !important; }
        .fc-timeGridWeek-view .fc-timegrid-event-harness { left: 0 !important; right: 0 !important; }
        .fc-timeGridWeek-view .fc-timegrid-col-events { margin: 0 !important; }
        .fc-timeGridWeek-view .fc-col-header-cell-cushion { cursor: pointer; }
        .fc-timeGridWeek-view .fc-col-header-cell-cushion:hover { text-decoration: underline; }
        /* Festivos */
        .fc-dayGridMonth-view .pwgs-dia-festivo .fc-daygrid-day-number,
        .fc-timeGridWeek-view .pwgs-dia-festivo .fc-col-header-cell-cushion,
        th.pwgs-dia-festivo .fc-col-header-cell-cushion {
          background: #28a745 !important; color: #fff !important; border-radius: 4px; padding: 1px 7px; font-weight: 600;
        }
        .fc .fc-col-header-cell.col-preferente { background: #f9cc98 !important;
         }
        /* Neutraliza el hover "expandible" que inyecta el planning global */
        .pwgs-bloqueos .fc-timegrid-event-harness:hover .fc-timegrid-event,
        .pwgs-bloqueos .fc-timegrid-event:hover {
          min-height: 0 !important;
          transform: none !important;
          box-shadow: none !important;
        }
        .pwgs-bloqueos .fc-timegrid-event { overflow: hidden !important; }
         .pwgs-watermark { position:absolute; right:4px; font-size:0.65em; color:rgba(0,0,0,0.13); pointer-events:none; user-select:none; z-index:1; line-height:1; }
        .pwgs-watermark.hora-entera { color:rgba(0,0,0,0.20); font-weight:600; }
      `;
      document.head.appendChild(s);
    },

    // ── Recursos (operarios como columnas) ────────────────────────────────────
    cargarRecursos() {
      if (!this.operarios) return;
      const recursos = [];
      const seleccionados = Array.isArray(this.operariosseleccionados) ? this.operariosseleccionados : [];
      const operariosOrdenados = [...Object.values(this.operarios)].sort((a, b) =>
        (a.nombre || '').localeCompare(b.nombre || '', 'es')
      );
      for (const op of operariosOrdenados) {
        if (!op.nombre) continue;
        if (seleccionados.length > 0 && !seleccionados.includes(op.idoperario)) continue;
        recursos.push({
          id: String(op.idoperario),
          title: op.nombre,
          name: op.nombre,
          extendedProps: {
            carga: op.carga_operario,
            guardia: op.guardia,
            preferente: op.preferente_operario,
            observaciones: op.observaciones_operario,
          },
        });
      }
      this.calendarOptions.resources = recursos;
      this.operariosDisponibles = recursos.map(r => ({ id: r.id, label: r.title }));
      this.ocultar = recursos.length === 0;
    },

    buildResourceLabelContent(arg) {
      const ep = arg.resource.extendedProps || {};
      const nombreCompleto = arg.resource.title;
      const nombreCorto = nombreCompleto.length > 27 ? nombreCompleto.substring(0, 24) + '…' : nombreCompleto;
      let html = `<strong title="${nombreCompleto}">${nombreCorto}</strong><br>`;
      if (ep.preferente == 1) html += `<strong>[Preferente]</strong>`;
      if (ep.guardia == 1) html += `<strong>[Guardia]</strong>`;
      if (ep.observaciones) html += `<i title="Observaciones\n${ep.observaciones}" class="pi pi-exclamation-triangle" style="color:#f00"></i>`;
      html += ` <strong>[${ep.carga || 0}%]</strong>`;
      return { html };
    },

    buildSlotLabelContent(arg) {
      const hh = String(arg.date.getHours()).padStart(2, '0');
      const mm = String(arg.date.getMinutes()).padStart(2, '0');
      return { html: `<span>${hh}:${mm}</span>` };
    },

    // ── Contenido del evento (solo lectura salvo eliminar vacaciones) ────────────
    buildEventContent(arg) {
      const ep = arg.event.extendedProps;
      const tipo = ep.tipo || arg.event.title;

      if (tipo === 'RESUMEN') {
        const d = new Date(ep.franjaIni);
        const hora = `${String(d.getHours()).padStart(2,'0')}:${String(d.getMinutes()).padStart(2,'0')}`;
        return { html: `<div style="height:100%;display:flex;justify-content:flex-end;font-size:0.7em;color:#555;padding:1px 3px;overflow:hidden">
          <span>${hora}</span></div>` };
      }
      if (tipo === 'CONTADOR') {
        let h = `<div style="display:flex;gap:3px;flex-wrap:wrap;padding:1px;justify-content:center">`;
        if (ep.activas > 0)
          h += `<span title="Activas" style="background:#ffe88c;color:#000;border-radius:3px;padding:0 5px;font-weight:bold;font-size:0.85em">${ep.activas}</span>`;
        if (ep.confirmar > 0)
          h += `<span title="Por confirmar" style="background:#f89393;color:#000;border-radius:3px;padding:0 5px;font-weight:bold;font-size:0.85em">${ep.confirmar}</span>`;
        if (ep.finalizadas > 0)
          h += `<span title="Finalizadas" style="background:#e8eff4;color:#000;border-radius:3px;padding:0 5px;font-weight:bold;font-size:0.85em">${ep.finalizadas}</span>`;
        h += `</div>`;
        return { html: h };
      }
      if (tipo === 'FESTIVO_MES') {
        return { html: `<span title="Festivo: ${ep.festivostitle}" style="background:#126e12;color:#fff;border-radius:3px;padding:0 6px;font-weight:bold;font-size:0.85em">F</span>` };
      }

      const especiales = ['GUARDIA','OCUPADO','BLOQUEADO','VACACIONES','RESERVA'];
      if (especiales.includes(tipo)) {
        const alineacion = { GUARDIA:'flex-start', OCUPADO:'flex-end', BLOQUEADO:'center', VACACIONES:'flex-start', RESERVA:'center' };
        let botonEliminar = '';
        if (tipo === 'VACACIONES' || tipo === 'BLOQUEADO') {
          botonEliminar = `<div class="fc-event-btns" style="display:flex;justify-content:center;margin-top:2px;opacity:0;transition:opacity 0.15s;pointer-events:auto">
            <button title="Eliminar ${tipo === 'VACACIONES' ? 'vacaciones' : 'bloqueo'}"
              style="background:#fffa;border:1px solid #0002;border-radius:3px;padding:1px 4px;font-size:0.7em;cursor:pointer;color:#c00;line-height:1.2"
              onmousedown="event.stopPropagation();event.preventDefault();"
              ontouchstart="event.stopPropagation();"
              onclick="event.stopPropagation();window.__fcBloqEliminar('${ep.id_visita || ''}','${ep.idservicio || ''}','${tipo}','${ep.id_bloqueo || ''}','${ep.id_operario || ''}')">
              <i class="fas fa-times"></i>
            </button>
          </div>`;
        }
        return { html: `<div style="height:100%;display:flex;flex-direction:column;justify-content:${alineacion[tipo] || 'center'};text-align:center;font-weight:bold;padding:2px;box-sizing:border-box">${tipo}${botonEliminar}</div>` };
      }

      // Cita normal: informativa
      const color = ep.color || '#ffe88c';
      const coloresTextoNegro = ['#ffe88c', '#e8eff4', '#f5c505'];
      const textColor = coloresTextoNegro.includes(color.toLowerCase()) ? 'black' : 'white';
      const pob = ep.poblacion ? this.decode_utf8(ep.poblacion) : '';
      const cp = ep.cp || '';
      const colorKm = ep.color_km || '';
      let html = `<div style="background-color:${color};border:1px solid #000;color:${textColor};display:flex;flex-direction:column;justify-content:flex-start;padding:2px;height:100%;overflow:hidden;box-sizing:border-box">`;
      html += `<div style="font-size:0.8em;font-weight:bold;line-height:1.1;white-space:normal;word-break:break-word">${pob}`;
      if (cp) html += `&nbsp;<span style="background-color:${colorKm}">(${cp})</span>`;
      html += `</div></div>`;
      return { html };
    },
  // ── Marcas de agua con la hora dentro de cada columna ─────────────────────
    ponerMarcasDeAgua() {
      setTimeout(() => {
        // Limpiar las anteriores para no duplicarlas al recargar
        const cont = this.$refs.fullCalendar?.$el;
        if (!cont) return;
        cont.querySelectorAll('.pwgs-watermark').forEach(el => el.remove());

        const lanes = cont.querySelectorAll('td.fc-timegrid-slot-lane[data-time]');
        // Una columna por operario (excluimos el eje de horas)
        const frames = cont.querySelectorAll('.fc-timegrid-col:not(.fc-timegrid-axis) .fc-timegrid-col-frame');
        if (!lanes.length || !frames.length) return;

        lanes.forEach(td => {
          const timeStr = td.getAttribute('data-time') || '';
          const hh = timeStr.substring(0, 2);
          const mm = timeStr.substring(3, 5);
          if (!hh || !mm) return;
          const isHour = mm === '00';
          const top = td.offsetTop;
          frames.forEach(frame => {
            const span = document.createElement('span');
            span.className = 'pwgs-watermark' + (isHour ? ' hora-entera' : '');
            span.textContent = hh + ':' + mm;
            span.style.top = (top + 2) + 'px';
            frame.appendChild(span);
          });
        });
      }, 300);
    },
    // ── Festivos ──────────────────────────────────────────────────────────────
    buscarFestivo(dateStr) {
      const f = (this.listadofestivos || []).find(x => (x.fecha || '').substring(0, 10) === dateStr);
      return f ? (f.nombre || 'Festivo') : '';
    },
    marcarFestivoCelda(arg) {
      const d = arg.date;
      const dia = `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
      return this.buscarFestivo(dia) ? ['pwgs-dia-festivo'] : [];
    },
    async cargarfestivos() {
      try {
        const api = new PwgsApi();
        const aux = await api.get(`festivos/${this.anyoactual}`);
        this.listadofestivos = aux.datos || [];
        this.comprobarfestivos();
        if (this._enMes) this.$refs.fullCalendar?.getApi()?.render();
      } catch (e) { console.log(e); }
    },
    comprobarfestivos() {
      const festivo = this.listadofestivos.find(f => {
        const fd = new Date(f.fecha);
        return fd.getFullYear() == this.anyoactual && fd.getMonth() + 1 == this.mesactual && fd.getDate() == this.diaactual;
      });
      this.$nextTick(() => {
        const el = document.querySelector('.fc-toolbar-title');
        if (!el) return;
        el.querySelector('.pwgs-festivo-nombre')?.remove();
        el.style.background   = festivo ? '#28a745' : '';
        el.style.color        = festivo ? 'white'   : '';
        el.style.padding      = festivo ? '4px 8px' : '';
        el.style.borderRadius = festivo ? '4px'     : '';
        if (festivo && this._viewType === 'resourceTimeGridDay') {
          const span = document.createElement('span');
          span.className = 'pwgs-festivo-nombre';
          span.style.cssText = 'font-size:0.45em;margin-left:10px;vertical-align:middle;font-weight:600;';
          span.textContent = festivo.nombre ? `Festivo: ${festivo.nombre}` : 'Festivo';
          el.appendChild(span);
        }
      });
    },

    // ── Carga de eventos ──────────────────────────────────────────────────────
    async fetchEvents(fetchInfo, successCallback, failureCallback) {
      try {
        const api = new PwgsApi();
        const start = fetchInfo.startStr.substring(0, 10);
        const end   = fetchInfo.endStr.substring(0, 10);
        const diasRango = Math.round((fetchInfo.end.getTime() - fetchInfo.start.getTime()) / 86400000);
        const esMes = diasRango > 14;

        if (esMes) {
          const mid = new Date((fetchInfo.start.getTime() + fetchInfo.end.getTime()) / 2);
          this.anyoactual = String(mid.getFullYear());
          this.mesactual  = mid.getMonth() + 1;
          this.diaactual  = 1;
        } else {
          this.anyoactual = String(fetchInfo.start.getFullYear());
          this.mesactual  = fetchInfo.start.getMonth() + 1;
          this.diaactual  = fetchInfo.start.getDate();
        }
        this.comprobarfestivos();

        if (esMes) {
          this._enMes = true;
          successCallback(await this.cargarContadorMes(this.anyoactual, this.mesactual));
          return;
        }
        this._enMes = false;

        const cuerpo = { start: `${start}T00:00:00`, end: `${end}T23:59:00`, id_servicio: 0 };
        if (this.guardia === true || this.guardia === false) cuerpo.guardia = this.guardia;

        const miseventos = await api.post('planning-pwgs', cuerpo);
        const especiales = ['GUARDIA','OCUPADO','BLOQUEADO','VACACIONES','RESERVA'];

        const sel = Array.isArray(this.operariosseleccionados) ? this.operariosseleccionados : [];
        const filtrar = sel.length > 0;
        const selStr = sel.map(x => String(x));

        const esSemana = diasRango === 7;
        const eventos = [];
        const resumenSemana = {};

        if (esSemana) this.construirIndiceSemana(miseventos);

        for (const ev of (miseventos || [])) {
          const esEspecial = especiales.includes(ev.title);

          // ── VISTA SEMANAL: franjas de 30 min ──
          if (esSemana) {
            if (filtrar && !selStr.includes(String(ev.id_operario))) continue;
            if (esEspecial) continue;
            const s = new Date(ev.start);
            const e = new Date(ev.end);
            if (isNaN(s)) continue;
            const porConfirmar = (ev.color || '').toLowerCase() === '#ff4646';
            if (porConfirmar && s.toDateString() !== e.toDateString()) continue;
            const finalizada = (ev.color || '').toLowerCase() === '#e8eff4';
            const slotMs = 30 * 60000;
            let t = Math.floor(s.getTime() / slotMs) * slotMs;
            for (; t < e.getTime(); t += slotMs) {
              const dFr = new Date(t);
              const diaFr = `${dFr.getFullYear()}-${String(dFr.getMonth()+1).padStart(2,'0')}-${String(dFr.getDate()).padStart(2,'0')}`;
              if (!resumenSemana[diaFr]) resumenSemana[diaFr] = new Map();
              const prev = resumenSemana[diaFr].get(t);
              resumenSemana[diaFr].set(t, {
                todasFinalizadas: (prev ? prev.todasFinalizadas : true) && finalizada,
                count: (prev ? prev.count : 0) + 1,
              });
            }
            continue;
          }

          // ── VISTA DIARIA ──
          let startEvt, endEvt;
          if ((ev.title === 'GUARDIA' || (ev.title === 'OCUPADO' && ev.dow)) && ev.dow) {
            const horaIni = (ev.start || '').padStart(5, '0');
            const horaFin = (ev.end   || '').padStart(5, '0');
            for (const day of ev.dow) {
              const offset = Number(day) - 1;
              const [d, m, a] = this.sumarDias(this.diaactual, this.mesactual, this.anyoactual, offset).split('-');
              startEvt = new Date(`${a}-${m}-${d}T${horaIni}`);
              endEvt   = new Date(`${a}-${m}-${d}T${horaFin}`);
              eventos.push(this._buildFCEvent(ev, startEvt, endEvt, esEspecial));
            }
            continue;
          }
          if (ev.title === 'GUARDIA' || (ev.title === 'OCUPADO' && ev.dow)) {
            const horaIni = (ev.start || '').padStart(5, '0');
            const horaFin = (ev.end   || '').padStart(5, '0');
            startEvt = new Date(`${start}T${horaIni}`);
            endEvt   = new Date(`${start}T${horaFin}`);
          } else {
            startEvt = new Date(ev.start);
            endEvt   = new Date(ev.end);
            const porConfirmar = (ev.color || '').toLowerCase() === '#ff4646';
            const distintoDia =
              startEvt.getFullYear() !== endEvt.getFullYear() ||
              startEvt.getMonth()    !== endEvt.getMonth()    ||
              startEvt.getDate()     !== endEvt.getDate();
            if (porConfirmar && distintoDia) {
              endEvt = new Date(startEvt.getFullYear(), startEvt.getMonth(), startEvt.getDate(),
                endEvt.getHours(), endEvt.getMinutes(), endEvt.getSeconds());
              if (endEvt <= startEvt) endEvt = new Date(startEvt.getTime() + 3600000);
            }
          }
          eventos.push(this._buildFCEvent(ev, startEvt, endEvt, esEspecial));
        }

        if (esSemana) {
          const slotMs = 30 * 60000;
          for (const [dia, franjas] of Object.entries(resumenSemana)) {
            for (const [ini, infoF] of franjas) {
              eventos.push({
                id: `resumen_${dia}_${ini}`,
                title: '',
                start: new Date(ini),
                end: new Date(ini + slotMs),
                display: 'block',
                editable: false,
                color: infoF.todasFinalizadas ? '#e8eff4' : '#ffe88c',
                classNames: ['RESUMEN'],
                extendedProps: { tipo: 'RESUMEN', dia, franjaIni: ini, franjaFin: ini + slotMs, count: infoF.count },
              });
            }
          }
        }
        successCallback(eventos);
        this.$nextTick(() => setTimeout(() => this.ponerMarcasDeAgua(), 200));
      }
      catch (err) {
        console.error('Error fetchEvents:', err);
        failureCallback(err);
      }
      finally { this.spinner = false; }
    },

    _buildFCEvent(ev, startEvt, endEvt, esEspecial) {
      return {
        id: String(ev.id) + '_' + Math.random(),
        resourceId: String(ev.id_operario),
        title: ev.title,
        start: startEvt,
        end: endEvt,
        color: esEspecial ? 'transparent' : (ev.color || '#ffe88c'),
        display: ev.rendering === 'background' ? 'background' : 'block',
        classNames: esEspecial ? [ev.title] : [],
        editable: false,
        durationEditable: false,
        startEditable: false,
        extendedProps: {
          tipo: ev.title,
          color: ev.color,
          color_km: ev.color_km,
          poblacion: ev.poblacion,
          cp: ev.cp,
          content: ev.description,
          idservicio: ev.id_servicio,
          id_visita: ev.id,
          id_vacaciones: ev.id_vacaciones,
          id_operario: ev.id_operario,
        },
      };
    },

    construirIndiceSemana(miseventos) {
      const especiales = ['GUARDIA','OCUPADO','BLOQUEADO','VACACIONES','RESERVA'];
      const sel = Array.isArray(this.operariosseleccionados) ? this.operariosseleccionados.map(String) : [];
      const filtrar = sel.length > 0;
      const mapaOp = {};
      for (const op of Object.values(this.operarios || {})) mapaOp[String(op.idoperario)] = op.nombre;

      const idx = {};
      for (const ev of (miseventos || [])) {
        if (filtrar && !sel.includes(String(ev.id_operario))) continue;
        if (especiales.includes(ev.title)) continue;
        const startEvt = new Date(ev.start);
        const endEvt   = new Date(ev.end);
        if (isNaN(startEvt)) continue;
        const dia = `${startEvt.getFullYear()}-${String(startEvt.getMonth()+1).padStart(2,'0')}-${String(startEvt.getDate()).padStart(2,'0')}`;
        (idx[dia] = idx[dia] || []).push({
          operario: mapaOp[String(ev.id_operario)] || '—',
          color: ev.color || '#ffe88c',
          titulo: this.decode_utf8(ev.poblacion || '') || 'Cita',
          horaIni: this.formatHora(startEvt),
          horaFin: this.formatHora(endEvt),
          referencia: ev.title || '',
          ts: startEvt.getTime(),
          tsFin: endEvt.getTime(),
          descripcion: this.decode_utf8(ev.description || ''),
          direccion: this.decode_utf8(ev.direccion || ''),
        });
      }
      for (const dia of Object.keys(idx)) idx[dia].sort((a, b) => a.ts - b.ts);
      this._citasPorDia = idx;
    },

    async cargarContadorMes(anyo, mes) {
      const api = new PwgsApi();
      const eventos = [];
      this._citasPorDia = {};
      this._diasCargadosMes = {};
      try {
        const datos = await api.get(`planning-pwgs/0/visitas-mes-dia?fecha=${parseInt(anyo)}-${parseInt(mes)}-01`);
        for (const [fecha, info] of Object.entries(datos || {})) {
          const dia = String(fecha).substring(0, 10);
          if (!/^\d{4}-\d{2}-\d{2}$/.test(dia)) continue;
          eventos.push({
            id: 'cont_' + dia, title: 'CONTADOR', start: dia, allDay: true,
            display: 'block', editable: false, classNames: ['CONTADOR'],
            extendedProps: {
              tipo: 'CONTADOR',
              activas:     Number(info.activas)     || 0,
              confirmar:   Number(info.confirmar)   || 0,
              finalizadas: Number(info.finalizadas) || 0,
            },
          });
        }
      } catch (e) { console.log(e); }

      try {
        const festivos = await api.get(`festivos/${parseInt(anyo)}`);
        for (const f of (festivos.datos || [])) {
          const fd = new Date(f.fecha);
          if (fd.getMonth() + 1 == parseInt(mes)) {
            const dia = f.fecha.substring(0, 10);
            eventos.push({
              id: 'fest_' + f.fecha, title: 'FESTIVO_MES', start: dia, allDay: true,
              display: 'block', editable: false, classNames: ['FESTIVO_MES'],
              extendedProps: { tipo: 'FESTIVO_MES', festivostitle: f.nombre },
            });
          }
        }
      } catch (e) { console.log(e); }

      return eventos;
    },

    async cargarCitasDelDia(dia) {
      const api = new PwgsApi();
      const especiales = ['GUARDIA','OCUPADO','BLOQUEADO','VACACIONES','RESERVA'];
      const cuerpo = { start: `${dia}T00:00:00`, end: `${dia}T23:59:59`, id_servicio: 0 };
      if (this.guardia === true || this.guardia === false) cuerpo.guardia = this.guardia;
      const citas = await api.post('planning-pwgs', cuerpo);

      const mapaOp = {};
      for (const op of Object.values(this.operarios || {})) mapaOp[String(op.idoperario)] = op.nombre;
      const sel = Array.isArray(this.operariosseleccionados) ? this.operariosseleccionados.map(String) : [];
      const filtrar = sel.length > 0;

      const lista = [];
      for (const ev of (citas || [])) {
        if (!ev.start) continue;
        if (especiales.includes(ev.title)) continue;
        if (filtrar && !sel.includes(String(ev.id_operario))) continue;
        const ini = new Date(ev.start);
        const fin = new Date(ev.end);
        if (isNaN(ini)) continue;
        lista.push({
          operario: mapaOp[String(ev.id_operario)] || ev.title || '—',
          color: ev.color || '#ffe88c',
          titulo: this.decode_utf8(ev.poblacion || '') || 'Cita',
          horaIni: this.formatHora(ini),
          horaFin: this.formatHora(fin),
          referencia: ev.title || '',
          ts: ini.getTime(),
          tsFin: fin.getTime(),
          descripcion: this.decode_utf8(ev.description || ''),
          direccion: this.decode_utf8(ev.direccion || ''),
        });
      }
      lista.sort((a, b) => a.ts - b.ts);
      this._citasPorDia = this._citasPorDia || {};
      this._citasPorDia[dia] = lista;
      return lista;
    },

    async abrirDiaMes(dia, rect, jsEvent) {
      this._citasPorDia     = this._citasPorDia     || {};
      this._diasCargadosMes = this._diasCargadosMes || {};
      if (!this._diasCargadosMes[dia]) {
        try {
          await this.cargarCitasDelDia(dia);
          this._diasCargadosMes[dia] = true;
        } catch (e) { console.log(e); }
      }
      const hayCitas = (this._citasPorDia[dia] || []).length > 0;
      if (!hayCitas && !this.buscarFestivo(dia)) { this.overlayDiaVisible = false; return; }
      this.mostrarDia(dia, rect, jsEvent);
    },

    // ── Tooltips ──────────────────────────────────────────────────────────────
    mostrarDia(dateStr, rect, jsEvent) {
      this.franjaTooltip = null;
      const citas = (this._citasPorDia && this._citasPorDia[dateStr]) || [];
      const festivo = this.buscarFestivo(dateStr);
      if (!citas.length && !festivo) return;
      this.citasDiaHover = citas;
      const f = new Date(dateStr + 'T00:00:00');
      let titulo = f.toLocaleDateString('es-ES', { weekday:'long', day:'2-digit', month:'2-digit' });
      if (festivo) titulo += festivo === 'Festivo' ? ' · Festivo' : ' · Festivo: ' + festivo;
      this.tituloDiaHover = titulo;

      let x, y;
      if (jsEvent) { x = jsEvent.clientX + 12; y = jsEvent.clientY + 12; }
      else { x = rect.left; y = rect.bottom + 4; }
      const anchoTooltip = 330;
      const altoTooltip  = Math.min(window.innerHeight * 0.6, 40 + citas.length * 24);
      if (x + anchoTooltip > window.innerWidth) {
        x = (jsEvent ? jsEvent.clientX : rect.left) - anchoTooltip - 12;
        if (x < 8) x = window.innerWidth - anchoTooltip - 8;
      }
      if (y + altoTooltip > window.innerHeight) y = window.innerHeight - altoTooltip - 8;
      if (y < 8) y = 8;
      if (x < 8) x = 8;
      this.overlayDiaX = x;
      this.overlayDiaY = y;
      this.cancelarCerrarDia();
      this.overlayDiaVisible = true;
    },

    mostrarFranjaResumen(e, ep) {
      this.franjaTooltip = { ini: ep.franjaIni, dia: ep.dia };
      const todas = (this._citasPorDia && this._citasPorDia[ep.dia]) || [];
      const citas = todas.filter(c => c.ts < ep.franjaFin && c.tsFin > ep.franjaIni);
      this.citasDiaHover = citas;
      this.tituloDiaHover = '';
      let x = e.clientX + 12, y = e.clientY + 12;
      const anchoTooltip = 330;
      const altoTooltip = Math.min(window.innerHeight * 0.6, 60 + citas.length * 30);
      if (x + anchoTooltip > window.innerWidth) {
        x = e.clientX - anchoTooltip - 12;
        if (x < 8) x = window.innerWidth - anchoTooltip - 8;
      }
      if (y + altoTooltip > window.innerHeight) y = window.innerHeight - altoTooltip - 8;
      if (y < 8) y = 8;
      if (x < 8) x = 8;
      this.overlayDiaX = x;
      this.overlayDiaY = y;
      this.cancelarCerrarDia();
      this.overlayDiaVisible = true;
    },

    mostrarFestivoDia(dateStr, rect) {
      this.franjaTooltip = null;
      const festivo = this.buscarFestivo(dateStr);
      if (!festivo) return;
      this.citasDiaHover = [];
      this.tituloDiaHover = 'Festivo: ' + festivo;
      this.overlayDiaX = rect.left;
      this.overlayDiaY = rect.bottom + 4;
      this.cancelarCerrarDia();
      this._tooltipFestivo = true;
      this.overlayDiaVisible = true;
    },

    iniciarCerrarDia() { this._diaHideTimer = setTimeout(() => { this.overlayDiaVisible = false; }, 250); },
    cancelarCerrarDia() { if (this._diaHideTimer) { clearTimeout(this._diaHideTimer); this._diaHideTimer = null; } },
    iniciarCerrarOverlay() { this.overlayHideTimer = setTimeout(() => { this.overlayVisible = false; }, 300); },
    cancelarCerrarOverlay() { if (this.overlayHideTimer) { clearTimeout(this.overlayHideTimer); this.overlayHideTimer = null; } },
    cerrarop() { this.overlayVisible = false; this.overlayBloqVisible = false; },

    onEventDidMount(info) {
      const tipo = info.event.extendedProps.tipo || info.event.title;
      if (tipo === 'VACACIONES' || tipo === 'BLOQUEADO') {
        info.el.style.pointerEvents = 'auto';
      }
    },

    onEventMouseEnter(info) {
      const ep = info.event.extendedProps;
      const tipo = ep.tipo || info.event.title;

      if (tipo === 'RESUMEN') { this.cancelarCerrarDia(); this.mostrarFranjaResumen(info.jsEvent, ep); return; }

      if (tipo === 'VACACIONES' || tipo === 'BLOQUEADO') {
        this.descripcionbloq = ep.content || '';
        const rect = info.el.getBoundingClientRect();
        let bx = rect.right + 8;
        if (bx + 360 > window.innerWidth) bx = rect.left - 368;
        if (bx < 8) bx = 8;
        this.overlayBloqX = bx;
        this.overlayBloqY = rect.top;
        this.overlayBloqVisible = true;
        return;
      }
      if (['GUARDIA','OCUPADO','RESERVA','CONTADOR','FESTIVO_MES'].includes(tipo)) return;

      this.eventoHover = info.event;
      this.nombreevento = tipo;
      this.descripcionevento = `Inicio: ${this.formatHora(info.event.start)} Fin: ${this.formatHora(info.event.end)}  ${this.decode_utf8(ep.content || '')}`;
      const rect = info.el.getBoundingClientRect();
      this._posicionarOverlay(rect.right + 8, rect.top + 10);
      this.cancelarCerrarOverlay();
      this.overlayVisible = true;
    },

    onEventMouseLeave(info) {
      if ((info.event.extendedProps.tipo) === 'RESUMEN') { this.iniciarCerrarDia(); return; }
      this.iniciarCerrarOverlay();
      this.overlayBloqVisible = false;
    },

    _posicionarOverlay(x, y) {
      const anchoTooltip = 360, altoTooltip = 220;
      if (x + anchoTooltip > window.innerWidth) {
        x = x - anchoTooltip - 30;
        if (x < 8) x = window.innerWidth - anchoTooltip - 8;
      }
      if (y + altoTooltip > window.innerHeight) y = window.innerHeight - altoTooltip - 8;
      if (y < 8) y = 8;
      if (x < 8) x = 8;
      this.overlayX = x;
      this.overlayY = y;
    },

    // ── Nuevas vacaciones ─────────────────────────────────────────────────────────
    onSelect(info) {
      const api = this.$refs.fullCalendar?.getApi();
      if (api && api.view.type === 'dayGridMonth') { api.unselect(); return; }
      const idOperario = info.resource?.id || '';
      console.log('llega', info, info.resource._resource);
      this.operariosCita = [{id: info.resource?.id, 'label': info.resource?._resource.title}];
      this.operarioseleccionado = idOperario;
      this.abrirNuevaCita(info.start, info.end, idOperario);
      api?.unselect();
    },

    nuevasVacacionesDesdeFranja() {
      if (!this.franjaTooltip) return;
      this.overlayDiaVisible = false;
      const ini = new Date(this.franjaTooltip.ini);
      this.abrirNuevaCita(ini, new Date(ini.getTime() + 30 * 60000), '');
    },

    abrirNuevaCita(inicio, fin, idOperario) {
        this.cerrarop();
        this.overlayDiaVisible = false;
        const ini = inicio ? new Date(inicio) : new Date();
        // Por defecto, las vacaciones duran una hora desde la hora de inicio
        let fFin = new Date(ini.getTime() + 3600000);
        // Si se ha arrastrado para marcar un rango mayor, se respeta
        if (fin) {
          const fSel = new Date(fin);
          if (fSel > fFin) fFin = fSel;
        }
        this.fechaInicioVacaciones = ini;
        this.fechaFinVacaciones = fFin;
        this.descripcionVacaciones = '';
        if (!idOperario) {
          this.operariosCita = this.operariosDisponibles
          this.operarioseleccionado = '';
        }
        this.vacacionesVisible = true;
    },

    async guardarVacaciones(finicio, ffin) {
      const fLocal = d => new Date(d).toLocaleDateString('es-ES');
      const fh     = d => String(new Date(d).getHours()).padStart(2,'0');
      const fm     = d => String(new Date(d).getMinutes()).padStart(2,'0');
      if (this.clientedescripcion.length === 0) this.agregarvisita();
      if (this.clientedescripcion.length === 0) return;
      const clientes = this.clientedescripcion.map(cl => {
        const c = { id: cl.cliente, descripcion: cl.descripcion };
        if (cl.id_secundaria) c.id_secundaria = cl.id_secundaria;
        return c;
      });
      const subidadatos = {
        id_servicio: 0,
        fecha_cita_inicio: fLocal(finicio), fecha_cita_fin: fLocal(ffin),
        hora_cita_inicio: `${fh(finicio)}:${fm(finicio)}:00`,
        hora_cita_fin:    `${fh(ffin)}:${fm(ffin)}:00`,
        reserva: 0, vacaciones: 1, clientes,
        id_operario: this.operarioseleccionado,
        prioritaria_cita: this.prioritaria,
        no_modificar_cita: this.nomodificar,
      };
      const api = new PwgsApi();
      try {
        await api.post(`planning-pwgs/0/crear-visita`, subidadatos);
        this.$toast.add({ severity:'success', summary:'Enviado', detail:'Cita creada correctamente', life:2000 });
        this.vacacionesVisible = false;
        this.recargar();
      } catch (e) {
        this.$toast.add({ severity:'error', summary:'Error', detail:e, life:5000 });
        this.recargar();
      }
    },

    // ── Eliminar bloqueo / vacaciones ────────────────────────────────────────
    async eliminarBloque() {
      const v = this.bloqueAEliminar;
      if (!v) return;
      const api = new PwgsApi();

      // Las vacaciones viven en su propia tabla; las vacaciones son una visita
      let url;
      if (v.tipo === 'BLOQUEADO') {
        if (!v.id_vacaciones || !v.id_operario) {
          this.$toast.add({ severity:'error', summary:'Error', detail:'No se ha podido identificar las vacaciones', life:5000 });
          return;
        }
        url = `planning-pwgs/${v.id_operario}/eliminar-vacaciones/${v.id_vacaciones}`;
      } else {
        if (!v.idservicio || !v.id_visita) {
          this.$toast.add({ severity:'error', summary:'Error', detail:'No se ha podido identificar el periodo de vacaciones', life:5000 });
          return;
        }
        url = `planning-pwgs/${v.idservicio}/eliminar-visita/${v.id_visita}`;
      }

      try {
        await api.delete(url);
        this.$toast.add({ severity:'success', summary:'Eliminado',
          detail:(v.tipo === 'VACACIONES' ? 'Vacaciones eliminadas' : 'Bloqueo eliminado') + ' correctamente', life:2000 });
        this.bloqueConfirmar = false;
        this.recargar();
      } catch (e) {
        this.$toast.add({ severity:'error', summary:'Error', detail:e, life:5000 });
      }
    },

    // ── Vista / recarga ───────────────────────────────────────────────────────
    recargar() {
      const el = this.$refs.fullCalendar?.$el;
      if (el) {
        el.style.minHeight = el.offsetHeight + 'px';
        this._elCongelado = el;
      }
      this._bloquearScroll();
      this.$refs.fullCalendar?.getApi()?.refetchEvents();
    },

    onDatesSet(dateInfo) {
      const viewType = dateInfo.view.type;
      this.esVistaMes = viewType === 'dayGridMonth';
      this.esVistaDiaria = viewType === 'resourceTimeGridDay';
      if (this._viewType && this._viewType !== viewType) {
        this._viewType = viewType;
        const api = this.$refs.fullCalendar?.getApi();
        if ((viewType === 'dayGridMonth' || viewType === 'timeGridWeek') && api) api.removeAllEvents();
        this.$nextTick(() => api?.refetchEvents());
      } else {
        this._viewType = viewType;
      }
      if (this.anyoactual !== this._lastYear) {
        this._lastYear = this.anyoactual;
        this.cargarfestivos();
      } else {
        this.comprobarfestivos();
      }
      const f = dateInfo.view.currentStart;
      this.$emit('fecha-actual', `${f.getFullYear()}-${String(f.getMonth()+1).padStart(2,'0')}-${String(f.getDate()).padStart(2,'0')}`);
       this.$nextTick(() => setTimeout(() => this.ponerMarcasDeAgua(), 300));
    },

    onClickTitulo(e) {
      const titulo = e.target.closest('.fc-toolbar-title');
      if (!titulo) return;
      e.stopPropagation();
      e.preventDefault();
      this.$refs.calenddos?.toggle(e, titulo);
    },

    async datosgenerales() {
      const api = new PwgsApi();
      try {
        this.propiedadescalendario = await api.get('planning-pwgs/0/formulario-visita');
        if (this.propiedadescalendario?.planning_hora_ini)
          this.calendarOptions.slotMinTime = this.propiedadescalendario.planning_hora_ini + ':00:00';
        if (this.propiedadescalendario?.planning_hora_fin)
          this.calendarOptions.slotMaxTime = this.propiedadescalendario.planning_hora_fin + ':00:00';
        this.descripcionminima = this.propiedadescalendario.min_caracteres_descripcion_visita || 0;
      } catch (e) { console.log(e); }
    },
  },

  watch: {
    guardia()                { this.recargar(); },
    cambios()                { this.recargar(); },
    operariosseleccionados() { this.cargarRecursos(); this.recargar(); },
    operarios()              { this.cargarRecursos(); this.recargar(); },
    fechacal(val)            { if (val) this.$refs.fullCalendar?.getApi()?.gotoDate(val); },
    anyoactual(v, o)         { if (v !== o) this.cargarfestivos(); },
    fechacalddos(val) {
      if (!val) return;
      this.$refs.fullCalendar?.getApi()?.gotoDate(val);
      this.$refs.calenddos?.hide();
    },
  },

  mounted() {
    this._lastYear = String(new Date().getFullYear());
    this._viewType = 'resourceTimeGridDay';
    this.inyectarCSS();

    this.calendarOptions.datesSet             = this.onDatesSet;
    this.calendarOptions.select               = this.onSelect;
    this.calendarOptions.eventMouseEnter      = this.onEventMouseEnter;
    this.calendarOptions.eventMouseLeave      = this.onEventMouseLeave;
    this.calendarOptions.eventContent         = this.buildEventContent;
    this.calendarOptions.resourceLabelContent = this.buildResourceLabelContent;
    this.calendarOptions.resourceLabelClassNames = (arg) =>
      arg.resource.extendedProps.preferente == 1 ? ['col-preferente'] : [];
    this.calendarOptions.slotLabelContent     = this.buildSlotLabelContent;
    this.calendarOptions.events               = this.fetchEvents;
    this.calendarOptions.dayCellClassNames    = this.marcarFestivoCelda;
    this.calendarOptions.dayHeaderClassNames  = this.marcarFestivoCelda;
    this.calendarOptions.eventDidMount        = this.onEventDidMount;
    this.calendarOptions.customButtons.nuevasvacaciones.click = () => {
      const ahora = new Date();
      ahora.setMinutes(Math.floor(ahora.getMinutes() / 15) * 15, 0, 0);
      this.abrirNuevaCita(ahora, new Date(ahora.getTime() + 3600000), '');
    };

    // Handler global del botón eliminar dentro del bloque BLOQUEADO/VACACIONES
    window.__fcBloqEliminar = (idVisita, idServicio, tipo, idVacaciones, idOperario) => {
      this.bloqueAEliminar = {
        tipo,
        id_visita: idVisita,
        idservicio: idServicio,
        id_vacaciones: idVacaciones,
        id_operario: idOperario,
        content: this.descripcionbloq || '',
      };
      this.bloqueConfirmar = true;
    };

    this.cargarRecursos();
    this.datosgenerales();
    this.cargarfestivos();
    this.$nextTick(() => setTimeout(() => this.ponerMarcasDeAgua(), 800));

    this._tituloClickHandler = (e) => this.onClickTitulo(e);
    document.addEventListener('click', this._tituloClickHandler, true);

    // Hover sobre cabecera de día en semanal → festivo
    this._diaHoverHandler = (e) => {
      if (this._viewType === 'timeGridWeek') {
        const th = e.target.closest('.fc-col-header-cell[data-date]');
        if (th) {
          const dia = th.getAttribute('data-date');
          if (this.buscarFestivo(dia)) {
            this.cancelarCerrarDia();
            this.mostrarFestivoDia(dia, th.getBoundingClientRect());
          }
          return;
        }
        if (this._tooltipFestivo && !e.target.closest('.fc-overlay-panel')) {
          this._tooltipFestivo = false;
          this.iniciarCerrarDia();
        }
      }
    };
    const cont = this.$refs.fullCalendar?.$el || document;
    cont.addEventListener('mouseover', this._diaHoverHandler);

    this._diaClickFueraHandler = (e) => {
      if (!this.overlayDiaVisible) return;
      if (e.target.closest('.fc-overlay-panel')) return;
      if (this._enMes && e.target.closest('.fc-daygrid-day[data-date]')) return;
      this.overlayDiaVisible = false;
    };

    this._diaClickHandler = (e) => {
      // MES: 1 clic → tooltip del día · 2 clics → vista diaria
      if (this._enMes) {
        if (e.target.closest('.fc-overlay-panel')) return;
        const cell = e.target.closest('.fc-daygrid-day[data-date]');
        if (!cell) return;
        const dia   = cell.getAttribute('data-date');
        const ahora = Date.now();
        const api   = this.$refs.fullCalendar?.getApi();

        if (this._ultimoClickMes && this._ultimoClickMes.clave === dia && (ahora - this._ultimoClickMes.t) < 400) {
          clearTimeout(this._timerClickMes);
          this._timerClickMes = null;
          this._ultimoClickMes = null;
          this.overlayDiaVisible = false;
          api?.changeView('resourceTimeGridDay', dia);
          return;
        }
        this._ultimoClickMes = { clave: dia, t: ahora };
        const rect    = cell.getBoundingClientRect();
        const jsEvent = { clientX: e.clientX, clientY: e.clientY };
        clearTimeout(this._timerClickMes);
        this._timerClickMes = setTimeout(() => {
          this._timerClickMes = null;
          this.abrirDiaMes(dia, rect, jsEvent);
        }, 260);
        return;
      }
      // Semanal: clic en la cabecera del día → vista diaria
      if (this._viewType !== 'timeGridWeek') return;
      const th = e.target.closest('.fc-col-header-cell[data-date]');
      if (!th) return;
      const api = this.$refs.fullCalendar?.getApi();
      if (!api) return;
      this.overlayDiaVisible = false;
      api.changeView('resourceTimeGridDay', th.getAttribute('data-date'));
    };
    cont.addEventListener('click', this._diaClickHandler);
    document.addEventListener('click', this._diaClickFueraHandler);
  },

  beforeUnmount() {
    if (this._tituloClickHandler) document.removeEventListener('click', this._tituloClickHandler, true);
    const cont = this.$refs.fullCalendar?.$el || document;
    if (this._diaHoverHandler) cont.removeEventListener('mouseover', this._diaHoverHandler);
    if (this._diaClickHandler) cont.removeEventListener('click', this._diaClickHandler);
    if (this._diaClickFueraHandler) document.removeEventListener('click', this._diaClickFueraHandler);
    if (this._diaHideTimer) clearTimeout(this._diaHideTimer);
    if (this._timerClickMes) clearTimeout(this._timerClickMes);
    if (this.overlayHideTimer) clearTimeout(this.overlayHideTimer);
    delete window.__fcBloqEliminar;
  },
};
</script>

<style scoped>
.planning-fc-wrapper { position: relative; }
.spinner {
  width: 56px; height: 56px; border-radius: 50%;
  border: 9px solid #d9e3ff; border-right-color: #007bff;
  animation: sp 1s infinite linear;
  position: absolute; z-index: 30000; top: 20%; left: 50%; margin-left: -28px;
}
.fc-overlay-panel {
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 6px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.25);
  padding: 8px 12px;
  max-width: 350px;
  font-size: 0.9em;
}
@keyframes sp { to { transform: rotate(1turn); } }
</style>